"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.ai.title': 'Ask AI Strategy Assistant',
    'socialMediaPlan.ai.desc': 'The assistant analyzes your post library and suggests next steps.',
    'socialMediaPlan.ai.preset.topics': 'Best topics for engagement?',
    'socialMediaPlan.ai.preset.plan': 'Suggest content plan for next week',
    'socialMediaPlan.ai.preset.timing': 'Best time to publish?',
    'socialMediaPlan.ai.preset.summary': 'Monthly results summary',
    'socialMediaPlan.ai.ask': 'Ask AI',
    'socialMediaPlan.ai.error': 'AI assistant error. Please try again.',
};
